import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconParagraph: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconParagraph"><Path fillRule="evenodd" clipRule="evenodd" d="M7.75 4.5C5.817 4.5 4.25 6.067 4.25 8C4.25 9.933 5.817 11.5 7.75 11.5H9V4.5H7.75ZM10.5 4.5V20.1725C10.5 20.5868 10.1642 20.9225 9.75 20.9225C9.33579 20.9225 9 20.5868 9 20.1725V13H7.75C4.98858 13 2.75 10.7614 2.75 8C2.75 5.23858 4.98858 3 7.75 3H20.25C20.6642 3 21 3.33579 21 3.75C21 4.16421 20.6642 4.5 20.25 4.5H16V20.25C16 20.6642 15.6642 21 15.25 21C14.8358 21 14.5 20.6642 14.5 20.25V4.5H10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconParagraph;
